import { basenameFind, getMetaFromJcamp, getTargetProperty, } from "../common.js";
const zetaPotential = {
    jpath: ['spectra', 'zetaPotential'],
    find: basenameFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default zetaPotential;
//# sourceMappingURL=zetaPotential.js.map